// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6c5c7fb1","845":"15bf42aa"}[chunkId] + ".chunk.js";
};